// List of client log events that can be searched
// This file is kept separate for easy maintenance and updates

export const CLIENT_LOG_EVENTS_INFO = [
  'AUDIO_UPLOADED',
  'EDIT_NOTE_TEXT_AREA',
  'EDIT_NOTE_TEXT_AREA_CLICKED',
  'FETCHED_USER_MACROS',
  'LOGIN',
  'LOGOUT',
  'MODIFIED_ICD_10_CODE',
  'PROCESSING_STATUS_CHANGE',
  'READY_TO_RECORD_CLICK',
  'REVIEW_NOTE',
  'SAVED_NOTE',
  'SEARCHED_FOR_MACROS',
  'SUGGESTED_MACRO_ADDED',
  'UPLOAD_SAVE_NOTE',
];

export const CLIENT_LOG_EVENTS_ERROR = [
  'ERROR_LOGIN',
  'ERROR_MICROPHONE_PERMISSION',
];

// Combined list for backward compatibility
export const CLIENT_LOG_EVENTS = [
  ...CLIENT_LOG_EVENTS_INFO,
  ...CLIENT_LOG_EVENTS_ERROR,
];

